/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentCategoriesPropertiesEditViewComponent(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                                      $location: JS5Object, ContentEditService: JS5Object,
                                                      ModalService: JS5Object, BreadcrumbService: JS5Object,
                                                      $timeout: JS5Function, NotificationService: JS5Object,
                                                      PermissionsService: JS5Object, UtilsService: JS5Object) {

    const NOTIFICATION_TIMEOUT_SECONDS = 5;
    this.editData = {};

    const getData = () => {
        this.loadingIndicator.show = true;
        ContentEditService.getContentCategoryEditData().then((contentCategory: JS5Object) => {
            unpackEditData(contentCategory);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const unpackEditData = (contentCategory: JS5Object) => {
        const contentPathKeyword = UtilsService.getPathKeywordFromContentType(contentCategory.content.type);
        if (_.has(contentCategory, 'contentCategoryObject.category')) {
            contentCategory.languages = _.chain(_.get(contentCategory, 'languages')).partition({isDefault: true}).flatten().value();
            this.editData = _.cloneDeep(contentCategory);
            ContentEditService.originalContentCategoryObject = _.cloneDeep(contentCategory);
            this.originalVideoRolesLength = _.size(_.get(this, 'editData.contentCategoryObject.videoRoles'));
            ContentEditService.parentRoute = `/meta/${contentPathKeyword}/search`;
            _.set(this, 'contentBreadcrumb.location', `/meta/${contentPathKeyword}/edit/${_.get(ContentEditService, 'contentObject.id')}/categories`);
            _.set(this, 'contentBreadcrumb.name', _.get(ContentEditService, 'contentObject.name'));
            _.set(this, 'categoryBreadcrumb.name', _.get(ContentEditService, 'contentCategoryObject.category.name'));
        } else {
            $location.path(`/meta/${contentPathKeyword}/edit/${_.get(ContentEditService, 'contentObject.id')}/categories`);
        }
    };

    const saveHandler = () => {
        ContentEditService.contentCategoryObject = this.editData.contentCategoryObject;
        let currentSizeOfVideoRoles = _.size(_.get(this, 'editData.contentCategoryObject.videoRoles'));
        if (currentSizeOfVideoRoles > this.originalVideoRolesLength && currentSizeOfVideoRoles > 1) {
            let numberOfNewRolesToAssign = currentSizeOfVideoRoles - this.originalVideoRolesLength;
            var confirmMsgText = `This will assign ${numberOfNewRolesToAssign} video role(s) to this content category. This cannot be undone. Do you wish to continue?`;
            ModalService.showMessageModal({
                    messageText: confirmMsgText,
                    title: 'Save Content Category',
                    windowClass: 'confirm-modal-sm',
                    showOK: true,
                    okText: 'Yes',
                    pullCancelLeft: true
                },
                () => {
                    updateContentCategory();
                }
            );
        } else {
            if ($routeParams.contentCategoryId === '-1') {
                saveNewContentCategory();
            } else {
                updateContentCategory();
            }
        }
    };

    const updateContentCategory = () => {
        this.loadingIndicator.show = true;
        ContentEditService.saveContentCategoryEditData(this.editData).then(() => {
            NotificationService.createSuccessNotification('Content Category updated successfully', NOTIFICATION_TIMEOUT_SECONDS);
            getData();
            this.editorForm.$setPristine();
        }).catch(() => {
            NotificationService.createFailureNotification('Could not update Content Category');
            this.loadingIndicator.show = false;
        })
    };

    this.getCategoryName = () => {
        return _.get(this, 'editData.contentCategoryObject.category.name');
    };

    const saveNewContentCategory = () => {
        ContentEditService.saveContentCategoryEditData(this.editData).then(() => {
            NotificationService.createSuccessNotification('Content Category created successfully', NOTIFICATION_TIMEOUT_SECONDS);
            getData();
        }).catch(() => {
            NotificationService.createFailureNotification('Could not create new Content Category');
            this.loadingIndicator.show = false;
        })
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => {
                if (_.get(this, 'editData.contentCategoryObject.liveClippingEnabled')) {
                    return !_.get(this.editorForm, '$pristine') &&
                        _.get(this, 'editData.contentCategoryObject.liveClipCategory') &&
                        _.get(this, 'editData.contentCategoryObject.liveClipAcceptProfile')
                } else {
                    return !_.get(this.editorForm, '$pristine')
                }
            },
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                if ($routeParams.contentCategoryId !== '-1') {
                    getData();
                    this.editorForm.$setPristine();
                } else {
                    $location.url($route.current.rootRoute.replace(':id', $routeParams.id));
                }
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url($route.current.rootRoute.replace(':id', $routeParams.id))
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (!PermissionsService.isAdmin()) {
            $location.url('/login');
        } else {
            getData();
        }
        this.isCreatingNewContentCategory = $routeParams.contentCategoryId === '-1';
    };

    this.$onDestroy = () => {
        ContentEditService.originalEditData = null;
        ContentEditService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            ContentEditService.editorForm = this.editorForm;
            if (this.isCreatingNewContentCategory) {
                this.editorForm.$setDirty();
            }
            BreadcrumbService.editService = ContentEditService;
        });
    };
}

angular.module('prism-ui.content').component('contentCategoriesPropertiesEditView', {
    templateUrl: 'meta/content/editor/components/view/categories/editor/components/contentCategoriesPropertiesView/content-categories-properties-edit-view-template.html',
    controller: ContentCategoriesPropertiesEditViewComponent,
    bindings: {
        contentBreadcrumb: '<',
        categoryBreadcrumb: '<'
    }
});
